import { Dispatch } from "react"

import {SettingsCallApiActions} from "../actions";
import {SettingsCallApiActionTypes} from "../action-types";
import {Settings} from "../../domain/settings/settings";

export const SendSettingsCallApiListRequest = () => {
    return async (dispatch: Dispatch<SettingsCallApiActions>) => {
        dispatch({
            type: SettingsCallApiActionTypes.SETTINGS_CALL_API_REQUEST_SEND,
          });
    }
}

export const SettingsCallApiSuccess = (obj: Settings) => {
    return async (dispatch: Dispatch<SettingsCallApiActions>) => {
        dispatch({
            type: SettingsCallApiActionTypes.SETTINGS_CALL_API_SUCCESS,
            payload: obj,
        });
    }
}

export const SettingsCallApiListError = (error:string) => {
    return async (dispatch: Dispatch<SettingsCallApiActions>) => {
        dispatch({
            type: SettingsCallApiActionTypes.SETTINGS_CALL_API_ERROR,
            payload: error,
        });
    }
}

export const SettingsCallApiUpdateRequest = () => {
    return async (dispatch: Dispatch<SettingsCallApiActions>) => {
        dispatch({
            type: SettingsCallApiActionTypes.SETTINGS_CALL_API_UPDATE_REQUEST,
          });
    }
}

export const SettingsCallApiUpdateSuccess = (status: boolean) => {
    return async (dispatch: Dispatch<SettingsCallApiActions>) => {
        dispatch({
            type: SettingsCallApiActionTypes.SETTINGS_CALL_API_UPDATE_SUCCESS,
            payload: status,
          });
    }
}

export const SettingsCallApiUpdateError = (message: string) => {
    return async (dispatch: Dispatch<SettingsCallApiActions>) => {
        dispatch({
            type: SettingsCallApiActionTypes.SETTINGS_CALL_API_UPDATE_ERROR,
            payload: message,
          });
    }
}
